/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2022-2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { IFilterMachineData } from 'utilities/MachinesFilter';
import { IFilterSoftwareData } from 'utilities/SoftwareFilter';
import { actions } from './actionTypes';
import { IUser } from 'api/auth';

const makeActionCreator = (type, ...argNames) => {
  return function (...args) {
    const action = { type, payload: {} };
    argNames.forEach((arg, index) => {
      action.payload[argNames[index]] = args[index];
    });
    return action;
  };
};

export type setMachineListFilterType = (filter: IFilterMachineData) => any;
export const setMachineListFilter : setMachineListFilterType = makeActionCreator(actions.SET_MACHINE_FILTER, 'filter');
export type setSoftwareListFilterType = (filter: IFilterSoftwareData) => any;
export const setSoftwareListFilter : setSoftwareListFilterType = makeActionCreator(actions.SET_SOFTWARE_FILTER, 'filter');
export type setCurrentUserType = (user?: IUser) => any;
export const setCurrentUser: setCurrentUserType = makeActionCreator(actions.SET_CURRENT_USER, 'user');
/// \todo use correct type
export type setCommonListFilterType = (filter: IFilterMachineData) => any;
export const setCommonListFilter = makeActionCreator(actions.SET_COMMON_FILTER, 'filter');
export const setMachines = makeActionCreator(actions.SET_MACHINES, 'machines');
export const setSoftwareFavourites = makeActionCreator(actions.SET_SOFTWARE_FAVOURITES, 'favourites');
export const setMachineFavourites = makeActionCreator(actions.SET_MACHINE_FAVOURITES, 'favourites');
export type setMachineFavouriteType = (machineId: string, favourite: boolean) => any;
export const setMachineFavourite: setMachineFavouriteType = makeActionCreator(actions.SET_MACHINE_FAVOURITE, 'machineId', 'favourite');
export type setSoftwareFavouriteType = (softwareId: string, favourite: boolean) => any;
export const setSoftwareFavourite: setMachineFavouriteType = makeActionCreator(actions.SET_SOFTWARE_FAVOURITE, 'softwareId', 'favourite');
